import shouldShowSpotlightRollup from './shouldShowSpotlightRollup';
import SpotlightItem from '../store/schema/SpotlightItem';
import getStore from '../store/store';

interface SpotlightRollupData {
    unseenCount: number;
    senderNames: string;
}

/**
 * Gets the necessary data to render the spotlight rollup
 *
 * @returns SpotlightRollupData if rollup should be shown, or null if rollup
 * shouldn't be shown
 */
export default function getSpotlightRollupData(
    previousRowKey: string,
    folderId: string
): SpotlightRollupData {
    const unseenSenders: string[] = getStore()
        .spotlightItems.map((spotlightItem: SpotlightItem) => {
            if (spotlightItem.isUnseen) {
                return spotlightItem.senderName;
            }

            return null;
        })
        .filter(unseenSender => unseenSender !== null);

    if (!shouldShowSpotlightRollup(unseenSenders.length, previousRowKey, folderId)) {
        return null;
    }

    return {
        unseenCount: unseenSenders.length,
        senderNames: getSenderNamesForRollup(unseenSenders),
    };
}

/**
 * Get string for spotlight rollup (with senders list de-duped)
 */
const getSenderNamesForRollup = (unseenSenders: string[]): string => {
    const uniqueSenders = [];
    for (let i = 0; i < unseenSenders.length && uniqueSenders.length <= 2; i++) {
        const currentSender = unseenSenders[i];
        if (uniqueSenders.indexOf(currentSender) === -1) {
            uniqueSenders.push(currentSender);
        }
    }

    switch (uniqueSenders.length) {
        case 1:
            return uniqueSenders[0];
        case 2:
            return `${uniqueSenders[0]}, ${uniqueSenders[1]}`;
        default:
            return `${uniqueSenders[0]}, ${uniqueSenders[1]} + ${uniqueSenders.length - 2}`;
    }
};
